/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum WorkerStatuses {
    Inactive = 'Inactive',
    Active = 'Active',
    Authorized = 'Authorized',
    Offline = 'Offline'
}

